var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5H22V19.5H2V17.5H4V10.5C4 6.08172 7.58172 2.5 12 2.5C16.4183 2.5 20 6.08172 20 10.5V17.5ZM18 17.5V10.5C18 7.18629 15.3137 4.5 12 4.5C8.68629 4.5 6 7.18629 6 10.5V17.5H18ZM9 21.5H15V23.5H9V21.5Z",
    fill: "#ED1002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification3);
export default __webpack_public_path__ + "static/media/notification-3.68b59706a28fa7f1a89d2c96a5bc9329.svg";
export { ForwardRef as ReactComponent };